var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img_item",attrs:{"src":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }